var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-312 -160)",
    fill: "#bfbfbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m323.5 163c-0.82843 0-1.5 0.67157-1.5 1.5s0.67157 1.5 1.5 1.5 1.5-0.67157 1.5-1.5-0.67157-1.5-1.5-1.5z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.99 161c-1.2582 0.0145-2.1789-0.0306-2.9316 0.38477-0.37637 0.20766-0.67323 0.55938-0.83789 0.99804-0.16467 0.43867-0.22461 0.95958-0.22461 1.6172v4 4c0 0.65761 0.0599 1.1785 0.22461 1.6172 0.16467 0.43865 0.46152 0.79039 0.83789 0.99804 0.75275 0.41532 1.6734 0.3702 2.9316 0.38477h4e-3 2.002 4.125 2.002 4e-3c1.2582-0.0146 2.1789 0.0306 2.9316-0.38477 0.37637-0.20765 0.67322-0.55939 0.83789-0.99804 0.16453-0.43866 0.38385-0.9792 0.22443-1.6172v-4-4c0-0.65761-0.0599-1.1785-0.22461-1.6172-0.16466-0.43866-0.46152-0.79038-0.83789-0.99804-0.75275-0.41537-1.6734-0.37027-2.9316-0.38477h-4e-3 -2.0019-4.125-2.002zm2.0059 1h4.125c2 0 3.4845-0.0156 4.2266 0.22461 0.98348 0.44721 0.77344 1.7754 0.77344 2.7754-8.5e-4 2.1232-0.0362 4.677-0.125 7h-4.875-4.125-4.875c-0.0888-2.323-0.12415-4.8768-0.125-7 0-1-0.21004-2.3282 0.77344-2.7754 0.74219-0.24023 2.2266-0.22461 4.2266-0.22461z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318 165.5-3 5.5h2.7182 5.2818l-2.5-4.5-1 1.5z",
    color: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSvg);
export default __webpack_public_path__ + "static/media/imgSvg.7b8a39acbf3a5bf404670fa9b62d6f68.svg";
export { ForwardRef as ReactComponent };